import React from 'react';
import DateInputComponent from './DateInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import {
  isAskaFlow,
  isCitizinsFlow,
} from '../../../../../../common/src/utils/globalVariables';
import DateInputPickerComponent from './DateInputPickerComponent';

interface Props {
  question: FlowsQuestion;
}
const DateInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  if (isAskaFlow() || isCitizinsFlow()) {
    return <DateInputPickerComponent question={question} />;
  }
  return <DateInputComponent question={question} />;
};

export default DateInputPicker;
